/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const calendar_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M6.5 1v5m11-5v5m-16 3.5v-5a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1v5m-21 0v12a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1v-12m-21 0h21"
    />
  </svg>
)
export default calendar_medium
